export default __webpack_public_path__ + "static/media/logo.952f2afc.png";